
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../config.js';

export const useCreatePaymentListMutation = ({ setsnackbarStatus, setPaymentListModalOpen, setmodalPosition, isAddToList = false }) => {

    const queryClient = useQueryClient();

    return useMutation({

        mutationFn: ({ updaterData }) => {


            return axios.post(
                `${config.API_URL}/payment/${isAddToList ? 'modifyActivePaymentList' : 'createActivePaymentList'}`,
                updaterData,
                { withCredentials: true }
            );
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'] , refetchType: 'active'}, {cancelRefetch: false});
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentList'] , refetchType: 'active'}, {cancelRefetch: false});



            queryClient.invalidateQueries({ queryKey: ['ActivePaymentListAggr'], refetchType: 'active'}, {cancelRefetch: false });
            queryClient.invalidateQueries({ queryKey: ['ActivePaymentListGroup'] , refetchType: 'active'}, {cancelRefetch: false});
            queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'], refetchType: 'active'}, {cancelRefetch: false });
            setPaymentListModalOpen(false);
            setmodalPosition('100%');


            setsnackbarStatus(
                {
                    open: true,
                    message: isAddToList ? `Modify Active PaymentList Successful` : `Create Active PaymentList Successful`,
                    severity: 'success'
                }
            )

        },
        onError: (error, variables, context) => {
            console.log(error);


            if (error?.response?.status === 406) {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Create Active Payment List Already Active`,
                        severity: 'error'
                    }
                )
            } else {
                setsnackbarStatus(
                    {
                        open: true,
                        message: isAddToList ? `Failed to Modify Active Payment List` : `Failed to Create Active Payment List`,
                        severity: 'error'
                    }
                )
            }
        }
    })




}